"use client";

import React from "react";
import { useAuthRoute, AuthType } from "@/component/hooks/use-auth-route";

export const AuthRoute: React.FC<{
  children: React.ReactElement;
  authType: AuthType;
}> = ({ children, authType }) => {
  const isAuthorized = useAuthRoute(authType);
  if (!isAuthorized) return null;
  return children;
};
